import React from "react";
import "./landing.scss";
import Navbar from "./Navbar";
import Hero from "./Hero";
import PlatformStatement from "./PlatformStatement";
import Workflow from "./Workflow";
import Capabilities from "./Capabilities";
import ProductShowcase from "./ProductShowcase";
import FinalCTA from "./FinalCTA";
import Footer from "./Footer";

/**
 * Public marketing landing page, mounted at `/` for unauthenticated visitors
 * (see `app/Routes.js`). Does not touch authentication logic or any
 * authenticated dashboard code - it only links out to the existing
 * `/auth/login`, `/auth/register` and `/dashboard` routes.
 */
export default function LandingPage() {
  return (
    <div className="landing-page" style={{ background: "#fff" }}>
      <Navbar />
      <Hero />
      <PlatformStatement />
      <Workflow />
      <Capabilities />
      <ProductShowcase />
      <FinalCTA />
      <Footer />
    </div>
  );
}
